/* eslint-disable no-underscore-dangle */ import { createContextCache } from '@pothos/core';
const prismaClientCache = createContextCache((builder) => createContextCache((context) => typeof builder.options.prisma.client === "function" ? builder.options.prisma.client(context) : builder.options.prisma.client));
export function getClient(builder, context) {
    if (typeof builder.options.prisma.client === "function") {
        return prismaClientCache(builder)(context);
    }
    return builder.options.prisma.client;
}
export function getDMMF(builder) {
    var _client__baseDmmf;
    if ("dmmf" in builder.options.prisma && builder.options.prisma.dmmf) {
        return builder.options.prisma.dmmf.datamodel;
    }
    const client = builder.options.prisma.client;
    var _client__runtimeDataModel, _ref;
    return (_ref = (_client__runtimeDataModel = client._runtimeDataModel) !== null && _client__runtimeDataModel !== void 0 ? _client__runtimeDataModel : (_client__baseDmmf = client._baseDmmf) === null || _client__baseDmmf === void 0 ? void 0 : _client__baseDmmf.datamodel) !== null && _ref !== void 0 ? _ref : client._dmmf.datamodel;
}
//# sourceMappingURL=get-client.js.map
